import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CartWizardComponent } from './cart-wizard/cart-wizard.component';
import { OrderCompleteComponent } from './order-complete/order-complete.component';
import { ProductsListComponent } from './products-list/products-list.component';
import { ShopFrontComponent } from './shop-front/shop-front.component';

const routes: Routes = [
  {
    path: '',
    component: ShopFrontComponent
  },
  {
    path: 'products',
    component: ProductsListComponent
  },
  {
    path: 'cart/:id',
    component: CartWizardComponent
  },
  {
    path: 'ordercomplete/:g/:n/:o',
    component: OrderCompleteComponent
  },
  {
    path: 'ordercomplete/:g/:n/:o/:e/:d',
    component: OrderCompleteComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShopRoutingModule { }
